// removed by extract-text-webpack-plugin
module.exports = {"blockHeading":"ZbeEkkSTr0bDnglX8Jnat","filters":"_2B4TM3BmmzNPjnBppuzLwQ","filter":"_3Jb-vNAqytuwmlFIW1awRN","list-outer":"HcNuKrqlmy9TPMzUfErD6","list":"h8X6ZFcCpJQxB1lGrlp5M","searching":"_2sD061N6E41Savf--Iui1f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentFilterListBlock/DocumentFilterListBlock.module.scss
// module id = 751
// module chunks = 0